import React from 'react';
import { Typography, Statistic } from 'antd';
import moment from 'moment-timezone';
import type { FC } from 'react';

const { Text } = Typography;

export type DisplayType = 'text' | 'statistic';

export interface FormattedDateProps {
    dateToFormat: Date | null | undefined;
    format?: string;
    type?: DisplayType;
    title?: string;
    timezone?: string; // e.g., 'Europe/London'
    colorize?: boolean;
}

const FormattedDate: FC<FormattedDateProps> = ({
    dateToFormat,
    format = 'DD MMM YYYY, HH:mm:ss',
    type = 'text',
    title = '',
    timezone = 'UTC',
    colorize = true,
}) => {
    let color: string | undefined;
    let formattedDate = "Not Set";

    if (dateToFormat) {
        const now = moment().tz(timezone);
        const targetDate = moment(dateToFormat).tz(timezone);
        formattedDate = targetDate.format(format);

        if (colorize) {
            const diffInDays = targetDate.diff(now, 'days', true);

            if (diffInDays < 0) {
                color = 'var(--red)';
            } else if (diffInDays <= 1) {
                color = 'orange';
            }
        }
    }

    if (type === 'statistic') {
        return (
            <Statistic
                title={title}
                value={formattedDate}
                valueStyle={{ color }}
            />
        );
    }

    return <Text style={{ color }}>{formattedDate}</Text>;
};

export default FormattedDate;